/* eslint-disable jsx-a11y/accessible-emoji */
import React from 'react'
import styled, { up, css } from '@xstyled/styled-components'
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa'
import { ContainerFooter } from '../components/Container'
import { useLangKey } from '../components/I18nContext'

const Copyright = styled.div`
  color: light400;
  font-size: 12;
  font-family: monospace;
`

const Socials = styled.div`
  margin-top: 4;
  margin-right: -2;
  display: flex;

  ${up(
    'md',
    css`
      margin-left: auto;
      display: flex;
    `,
  )}
`

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44;
  width: 44;
  color: lighter;
  transition: base;

  &:hover,
  &:focus {
    outline: none;
    color: accent;
  }
`

const currentYear = new Date().getFullYear()

const locales = {
  es: {
    twitter: 'Mi perfil en Twitter',
    github: 'Mi perfil en GitHub',
    linkedin: 'Mi perfil en LinkedIn',
    email: 'Enviame un correo',
    instagram: 'Mi perfil de Instagram',
  },
  en: {
    twitter: 'My Twitter profile',
    github: 'My GitHub profile',
    linkedin: 'My LinkedIn profile',
    email: 'Send me an email',
    instagram: 'My Instagram profile',
  },
}

export function AppFooter() {
  const langKey = useLangKey()
  const t = locales[langKey]
  return (
    <ContainerFooter display="flex" alignItems="center" mt={4} pb={4}>
      <Copyright>🦁 León G. Martínez Ostos © {currentYear}</Copyright>
      <Socials>
        <SocialLink
          title={t.github}
          href="https://github.com/leon-webdev"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaGithub />
        </SocialLink>
        <SocialLink
          title={t.linkedin}
          href="https://www.linkedin.com/in/leonwebdev"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaLinkedin />
        </SocialLink>
        <SocialLink title={t.email} href="mailto:leonma19@gmail.com">
          <FaEnvelope />
        </SocialLink>
      </Socials>
    </ContainerFooter>
  )
}
